import reactStringReplace from 'react-string-replace';

import { Anchor, Alert as ConstAlert } from '@zillow/constellation-10';

import { LISTING_SUMMARY_DISPLAY_STATUS } from '../../../constants/ListingSummaryConstants';

import type { UserPropertySummaryListingSyndicationUniversalWebDto } from '@zg-rentals/ts-rental-manager-api-client';

type Props = {
  universal: UserPropertySummaryListingSyndicationUniversalWebDto | undefined;
  displayStatus: string;
};

const Alert = ({ universal, displayStatus }: Props) => {
  const message = universal?.message ?? '';
  const replaceText = universal?.partialMessages?.[0]?.text ?? '';
  const replaceUrl = universal?.partialMessages?.[0]?.url ?? '';

  if (!message || !replaceText) {
    return null;
  }

  const tone = displayStatus === LISTING_SUMMARY_DISPLAY_STATUS.DECLINED ? 'critical' : 'warning';

  const renderedMessage = reactStringReplace(message, replaceText, (_, i) => (
    <Anchor
      key={i}
      href={replaceUrl}
      target="_blank"
      rel="noopener noreferrer"
      css={{ _hover: { textDecoration: 'none' }, _visited: { color: 'text.accent.brand.hero' } }}
    >
      {replaceText}
    </Anchor>
  ));

  if (!message || !replaceText) {
    return null;
  }

  return <ConstAlert tone={tone}>{renderedMessage}</ConstAlert>;
};

export default Alert;
